import cx from 'classnames';
import styles from './inBlogPromotion.module.scss';

import { useTranslation } from '../../../lib/hooks';
import StyledLink from '../../StyledLink/StyledLink';
import AccessibleButton from '../../AccessibleButton/AccessibleButton';

/**
 * CTA for the InBlogPromotion component
 * @param {object} [props] component props
 * @param {object} [props.cta] component link
 * @param {string} [props.brand] brand
 * @returns {JSX.Element} cta component
 */
export default function InBlogPromotionCTA({ cta, brand }) {
  const isGoSolutions = brand === 'go-solutions';
  const { t } = useTranslation();

  // Render CTA if entry is a 'Link' content type
  const renderLinkCTA = cta.fields?.internalPage || cta.fields?.linkAddress;
  const linkHref = cta.fields.internalPage
    ? cta.fields.internalPage?.fields?.slug
    : cta.fields.linkAddress;

  // Render CTA if entry is a 'Template - Product' content type
  const renderProductCTA = cta.fields?.slug;
  const productCTAText = t('common.ctas.viewRecipe');

  if (renderLinkCTA) {
    return isGoSolutions ? (
      <StyledLink
        href={linkHref}
        type="primary"
        className={styles.cta}
        theme={isGoSolutions ? 'dark' : 'light'}>
        {cta.fields.linkText}
      </StyledLink>
    ) : (
      <AccessibleButton link={cta} type="primary" theme="light" className={styles.cta}>
        {cta.fields.linkText}
      </AccessibleButton>
    );
  }

  if (renderProductCTA) {
    return (
      <StyledLink
        href={cta.fields.slug}
        type="primary"
        className={cx(styles.cta, styles.productCta)}
        theme={isGoSolutions ? 'dark' : 'light'}>
        {isGoSolutions ? (
          productCTAText
        ) : (
          <AccessibleButton type="primary" theme="light">
            {productCTAText}
          </AccessibleButton>
        )}
      </StyledLink>
    );
  }

  return null;
}
